module.exports = __webpack_public_path__ + "static/media/Рябков К. (ММ).1c65fcb7.pdf";